export const API = process.env.REACT_APP_BACKEND_URL;
export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

export const STATUS_META = {
  not_yet: { label: 'Not yet', className: 'bg-slate-100 text-slate-700 border-slate-300', active: 'bg-slate-700 text-white border-slate-700' },
  taught: { label: 'Taught', className: 'bg-emerald-50 text-emerald-700 border-emerald-300', active: 'bg-emerald-600 text-white border-emerald-600' },
  carried_over: { label: 'Carried over', className: 'bg-amber-50 text-amber-800 border-amber-300', active: 'bg-amber-500 text-white border-amber-500' },
};

export const fetchWorkbook = (subject, year) =>
  fetch(`${API}/api/planning/workbook?subject=${encodeURIComponent(subject)}&year_level=${year}`, { headers: authHeaders() })
    .then((r) => (r.ok ? r.json() : Promise.reject(r)));

export const fetchSummary = (subject, year) =>
  fetch(`${API}/api/planning/summary?subject=${encodeURIComponent(subject)}&year_level=${year}`, { headers: authHeaders() })
    .then((r) => (r.ok ? r.json() : { workbook: null }));

export const setLessonStatus = (lessonId, status, note) =>
  fetch(`${API}/api/planning/lessons/${lessonId}/status`, {
    method: 'PUT', headers: { ...authHeaders(), 'Content-Type': 'application/json' }, body: JSON.stringify({ status, note }),
  }).then((r) => (r.ok ? r.json() : Promise.reject(r)));

export const uploadWorkbook = async (file, subject, year) => {
  const fd = new FormData();
  fd.append('subject', subject);
  fd.append('year_level', String(year));
  fd.append('file', file);
  const r = await fetch(`${API}/api/planning/upload`, { method: 'POST', headers: authHeaders(), body: fd });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || 'Upload failed');
  return r.json();
};

export const isCurrentWeek = (week, today) => {
  if (!week.week_of) return false;
  const start = new Date(week.week_of);
  const end = new Date(start); end.setDate(start.getDate() + 6);
  const t = new Date(today);
  return t >= start && t <= end;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' }) : '');
